import Vue from "vue";
import moment from "moment";

Vue.component("wto-datepicker", {
    props: ["value", "locale", "datetimeFormatter", "todayText", "clearText", "position", "placeholder", "minDate", "maxDate"],
    data() {
        return {
            pickerPosition: this.position ? this.position : ""
        };
    },
    computed: {
        computedValue: {
            get() {
                if (!this.value) return this.value;
                return moment(this.value).toDate();
            },
            set(value) {
                this.$emit("update:value", value != null ? this.formatDatePicker(value) : null);
            }
        }
    },
    methods: {
        formatDatePicker: function (value) {
            const localDate = moment(value).local();
            return localDate.format("YYYY-MM-DD");
        },
        onDataChange: function (val) {
            this.$emit('on-data-change', val);
        },
        addYears: function (year) {
            let date = new Date()
            date.setFullYear(date.getFullYear() + year);
            return date;
        }
    },
    template: `
	  <b-datepicker v-model="computedValue"
			  :locale="locale"
			  :position="position"
			  :datetime-formatter="datetimeFormatter"
			  :placeholder="placeholder"
			  :min-date="minDate ? minDate : addYears(-50)"
			  :max-date="maxDate ? maxDate : addYears(50)"		
			  icon="calendar-alt"
			  @input="onDataChange"
			  trap-focus>
			<div class="columns">
				<div class="column is-offset-one-fifth">							
						<button type="button" class="button is-danger" @click="computedValue = new Date()">
							<span><i class="fal fa-calendar-alt"></i> {{ todayText | decodeHTMLEntity }}</span>
						</button>

						<button type="button" class="button is-danger" @click="computedValue = null">
							<span><i class="fas fa-times"></i> {{ clearText | decodeHTMLEntity }}</span>
						</button>
				</div>
			</div>	
	</b-datepicker>
	`
});